const ACTION = {
    LOGIN: 'login',
    RECUPERAR_CONTRASENHA: 'recuperarContrasenha',
    VALIDADOR_DOCUMENTO: 'validadorDocumento',
    GD_CONSULTA_DOCUMENTO: 'gestorDocumentalConsultaDocumento',
    GD_CONSULTA_DOCUMENTO_VERSION: 'gestorDocumentalConsultaDocumentoVersion',
    CD_CONSULTA_DOCUMENTO: 'carpetaDigitalConsultaDocumento',
};
export default ACTION;
